import { Chip } from '@mui/material';

interface StatusChipProps {
  status: string;
  size?: 'medium' | 'small';
}

const StatusChip = ({ status, size = 'small' }: StatusChipProps) => {
  const chipColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'ready for collection':
      case 'loaded to transport':
        return 'rgb(47,199,38)';
      case 'not sending':
        return 'rgb(244,135,8)';
      case 'not scanned':
      default:
        return 'rgb(156,156,156)';
    }
  };

  if (!status) return null;

  return (
    <Chip
      label={status}
      size={size}
      sx={{
        backgroundColor: chipColor(status),
        color: '#fff',
        fontWeight: 600,
        textShadow: '1px 1px 1px rgba(0,0,0,0.6)'
      }}
    />
  );
};

export default StatusChip;
